(function () {
  'use strict';

  var TILE_VIEW_URL = '/products/{handle}?view=wishlist-tile';
  var WISHLIST_PATH_RE = /^\/account\/wishlist/i;

  function _storageAvailable() {
    return !!window.localStorage;
  }

  function _key() {
    return window.davinesWishlist._key();
  }

  function _empty() {
    return { ts: 0, handles: [] };
  }

  function _read() {
    return window.davinesWishlist._readState() || _empty();
  }

  function _write(state) {
    try {
      localStorage.setItem(_key(), JSON.stringify(state));
    } catch (e) {
      // graceful degrade with a warning
      console.error('wishlist-shadow.js.liquid -> _write operation of state to localStorage failed. state -> ', state);
    }
  }

  function _serverHandles() {
    return (window.davinesWishlist && window.davinesWishlist.serverHandles) || [];
  }

  function _isFresh(state) {
    return window.davinesWishlist._isFresh(state);
  }

  function _activeHandles() {
    var state = _read();
    if (_isFresh(state)) return state.handles;
    return _serverHandles();
  }

  function mark(handle, action, sku) {
    if (!handle || !_storageAvailable()) return;
    var state = _read();
    var now = Date.now();

    if (!_isFresh(state)) {
      state = { ts: now, handles: _serverHandles().slice() };
    }

    var idx = state.handles.indexOf(handle);
    if (action === 'add') {
      if (idx === -1) state.handles.push(handle);
    } else if (action === 'remove') {
      if (idx !== -1) state.handles.splice(idx, 1);
    }
    state.ts = now;
    _write(state);
  }

  function isInWishlist(handle) {
    var handles = _activeHandles();
    return handles.indexOf(handle) !== -1;
  }

  function applyToButtons(handle) {
    var inWishlist = isInWishlist(handle);
    var buttons = document.querySelectorAll(`.btn-to-wishlist[data-tag="${handle}"]`);
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      // Skip guest "open login popup" CTAs — they are a single, always-visible button.
      var onclick = btn.getAttribute('onclick') || '';
      if (onclick.indexOf('wishlist.message') !== -1) continue;
      var isAddIcon = btn.classList.contains('wishlist-add-icon');
      var isRemoveIcon = btn.classList.contains('wishlist-remove-icon');
      if (isAddIcon) {
        btn.style.display = inWishlist ? 'none' : 'block';
      } else if (isRemoveIcon) {
        btn.style.display = inWishlist ? 'block' : 'none';
      }
    }
  }

  function applyAllButtons() {
    var buttons = document.querySelectorAll('.btn-to-wishlist[data-tag]');
    var seen = {};
    for (var i = 0; i < buttons.length; i++) {
      var handle = buttons[i].getAttribute('data-tag');
      if (handle && !seen[handle]) {
        seen[handle] = true;
        applyToButtons(handle);
      }
    }
  }

  function _fetchAndInjectTile(handle) {
    var url = TILE_VIEW_URL.replace('{handle}', encodeURIComponent(handle));
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var container = document.querySelector('.content__wishlist-products .product-list');
        if (!container) return;
        if (document.querySelector(`.wishlist-account-tile[data-wishlist-handle="${handle}"]`)) return;
        var temp = document.createElement('div');
        temp.innerHTML = html.trim();
        var tile = temp.firstElementChild;
        if (!tile) return;
        container.appendChild(tile);
        applyToButtons(handle);
      })
      .catch(function () { /* silent degrade — keep banner fallback if present */ });
  }

  function applyEmptyState() {
    if (!location.href.includes('account?view=wishlist')) return;

    var state = _read();
    var hasItems;
    if (_isFresh(state)) {
      hasItems = state.handles.length > 0;
    } else {
      hasItems = document.querySelectorAll('.wishlist-account-tile[data-wishlist-handle]').length > 0;
    }

    var emptyEl = document.querySelector('#wishlist-email-link p.wishlist-message');
    if (emptyEl) emptyEl.classList.toggle('wishlist-message--empty', !hasItems);

    var shareEl = document.querySelector('#wishlist-email-link a.wishlist-message');
    if (shareEl) shareEl.classList.toggle('wishlist-message--share', hasItems);
  }

  function applyToAccountPage() {
    if (!location.href.includes('account?view=wishlist')) return;

    var state = _read();
    if (!_isFresh(state)) {
      applyEmptyState();
      return;
    }

    var localHandles = state.handles;

    // Hide tiles whose handle is not in localHandles.
    // The wishlist page has no add UI, so a removed tile won't need to be brought back
    // within the same session. Hidden HTML lives until the user reloads or navigates away,
    // at which point Liquid + hydrate() run fresh on the next render.
    var allTiles = document.querySelectorAll('.wishlist-account-tile[data-wishlist-handle]');
    for (var i = 0; i < allTiles.length; i++) {
      var tile = allTiles[i];
      var h = tile.getAttribute('data-wishlist-handle');
      tile.style.display = localHandles.indexOf(h) === -1 ? 'none' : '';
    }

    // Fetch + inject tiles for handles in localHandles that have no tile in DOM yet.
    for (var j = 0; j < localHandles.length; j++) {
      var lh = localHandles[j];
      if (document.querySelector('.wishlist-account-tile[data-wishlist-handle="' + lh + '"]')) continue;
      _fetchAndInjectTile(lh);
    }

    applyEmptyState();
  }

  function hydrate() {
    if (!_storageAvailable()) return;
    applyAllButtons();
    applyToAccountPage();
  }

  // Expose public API
  window.davinesWishlist = window.davinesWishlist || {};
  window.davinesWishlist.mark = mark;
  window.davinesWishlist.isInWishlist = isInWishlist;
  window.davinesWishlist.applyToButtons = applyToButtons;
  window.davinesWishlist.applyAllButtons = applyAllButtons;
  window.davinesWishlist.applyToAccountPage = applyToAccountPage;
  window.davinesWishlist.hydrate = hydrate;
  window.davinesWishlist._read = _read;
  window.davinesWishlist._write = _write;
  window.davinesWishlist._empty = _empty;

  hydrate();
}());
